import { Card,  Grid, Table, TableBody, TableCell, TableContainer,  TableHead, TablePagination, TableRow,  Typography} from '@mui/material';
import { useTheme } from '@mui/material/styles';

import { useEffect, useState } from 'react';

import axios from 'axios';




const TransactionHistory = () => {
    const theme = useTheme();
    const borderColor = theme.palette.grey[100];
 
    const [loader, setloader] = useState(false)
 
    document.title = "Talent Scan - Transaction History"
    const [userslist, setuserslist] = useState([])
 
    const [totalRows, setTotalRows] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [page, setPage] = useState(0);
 
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
        GetUsersList(newPage + 1, rowsPerPage);
    };
    const [userinfo, setuserinfo] = useState(JSON.parse(sessionStorage.getItem('user-info')))
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
        GetUsersList(1, event.target.value);
    };
    const GetUsersList = () => {
        setloader(false)
        axios.defaults.headers.common = { 'Authorization': `Bearer ${sessionStorage.getItem("Admintoken")}` }
        axios.get(`/apiV1/transaction-details/?page_size=10&page_number=1&customer=${userinfo.id}`).then((rep) => {
        
            setuserslist(rep.data.results            )
            setTotalRows(rep.data.count)
            setloader(true)
        }).catch((e) => {
            setloader(true)
             

        })
    }
    useEffect(() => {
        GetUsersList();
    }, [])
    return (
        <>
            <div className='pt-5'>
                <h4 className='mb-4'>Transaction History</h4>
                <Grid container>
                    <Grid item xs={12} lg={12} >
                        <Card
                            


                        >

                            {loader ? <><TableContainer sx={{ overflow: 'auto', maxHeight: 550, }} className='userCreationModalClass'>
                                <Table
                                    stickyHeader aria-label="sticky table"
                                    sx={{
                                        whiteSpace: 'nowrap',
                                    }}

                                >
                                    <TableHead>
                                        <TableRow>


                                            <TableCell>
                                                <Typography variant="subtitle2" fontWeight={600}>Transaction Date</Typography>
                                            </TableCell>
                                            <TableCell>
                                                <Typography variant="subtitle2" fontWeight={600}>Transaction ID</Typography>
                                            </TableCell>
                                            <TableCell>
                                                <Typography variant="subtitle2" fontWeight={600}>User</Typography>
                                            </TableCell>

                                           
                                            <TableCell>
                                                <Typography variant="subtitle2" fontWeight={600}>Amount</Typography>
                                            </TableCell>

                                            <TableCell>
                                                <Typography variant="subtitle2" fontWeight={600}>Type</Typography>
                                            </TableCell>
                                             
                                            <TableCell>
                                                <Typography variant="subtitle2" fontWeight={600}>Status</Typography>
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>

                                    <TableBody>
                                        {userslist.map((basic, userIndex) => (
                                            <TableRow key={basic.id}>
                                                <TableCell>
                                                     {basic.payment_date}
                                                </TableCell>
                                                <TableCell>
                                                {basic.transaction_id}
                                                </TableCell>
                                                <TableCell>
                                                {basic.customer__fullname}
                                                </TableCell>
                                                
                                                <TableCell >
                                                {basic.amount_paid}
                                                </TableCell>
                                                <TableCell >
                                                {basic.payment_method == "credit_card" ? "Credit Card" : "Debit Card" }
                                                
                                                </TableCell>
                                                <TableCell>
                                                {basic.payment_status == "completed" ? "Completed" : "Pending"}
                                                
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                        {userslist.length === 0 && (<TableRow><TableCell colSpan={7} sx={{ textAlign: "center", fontSize: "14px" }}>There are no records to display</TableCell></TableRow>)}
                                    </TableBody>

                                      
                                </Table>
                            </TableContainer>  <TablePagination
                                                rowsPerPageOptions={[10, 30, 50, { label: 'All', value: totalRows }]}
                                                colSpan={8}
                                                count={totalRows}
                                                rowsPerPage={rowsPerPage}
                                                page={page}
                                                 component="div"
                                                onPageChange={handleChangePage}
                                                onRowsPerPageChange={handleChangeRowsPerPage}
                                            /></>: <div className="loading component-loader">
                                <div className="effect-1 effects" />
                                <div className="effect-2 effects" />
                                <div className="effect-3 effects" />
                            </div>}
                        </Card>
                    </Grid>
                </Grid>
             
                </div>
        </>
    )
}
export default TransactionHistory